import { APIClient } from "../../helpers/api_helper";
import { PLAN_PRICING } from "../../helpers/url_helper";

// apiUtils.js
const api = new APIClient(); // Adjust the import based on your api setup

export const getPricingPlan = async (setPlanType) => {
    try {
        const response = await api.get(`${PLAN_PRICING}`);
        if (response.success === true) {
            const pricingPlanData = [
                { label: 'All', value: '' },
                ...(response?.data?.map((item) => ({
                    label: item?.planName,
                    value: item?.type,
                })) || [])
            ];
            
            setPlanType(pricingPlanData);
        }
    } catch (error) {
        console.error("API call error:", error);
    }
};
